const layout_lg = [
    { i: "a", x: 0, y: 0, w: 3, h: 2 },
    { i: "b", x: 3, y: 0, w: 3, h: 2 },
    { i: "c", x: 6, y: 0, w: 3, h: 2 },
    { i: "d", x: 9, y: 0, w: 3, h: 2 },
    { i: "e", x: 0, y: 0, w: 3, h: 2 },
    { i: "f", x: 3, y: 0, w: 3, h: 2 }
];

const layout_md = [
    { i: "a", x: 0, y: 0, w: 3, h: 2 },
    { i: "b", x: 3, y: 0, w: 3, h: 2 },
    { i: "c", x: 6, y: 0, w: 3, h: 2 },
    { i: "d", x: 6, y: 0, w: 3, h: 2 },
    { i: "e", x: 0, y: 0, w: 3, h: 2 },
    { i: "f", x: 3, y: 0, w: 3, h: 2 }
];

const layout_sm = [
    { i: "a", x: 0, y: 0, w: 3, h: 2 },
    { i: "b", x: 3, y: 0, w: 3, h: 2 },
    { i: "c", x: 0, y: 0, w: 3, h: 2 },
    { i: "d", x: 3, y: 0, w: 3, h: 2 },
    { i: "e", x: 0, y: 0, w: 3, h: 2 },
    { i: "f", x: 3, y: 0, w: 3, h: 2 }
];

const layout_xs = [
    { i: "a", x: 0, y: 0, w: 4, h: 2 },
    { i: "b", x: 0, y: 0, w: 4, h: 2 },
    { i: "c", x: 0, y: 0, w: 4, h: 2 },
    { i: "d", x: 0, y: 0, w: 4, h: 2 },
    { i: "e", x: 0, y: 0, w: 4, h: 2 },
    { i: "f", x: 0, y: 0, w: 4, h: 2 }
];

const layout_xxs = [
    { i: "a", x: 0, y: 0, w: 4, h: 2 },
    { i: "b", x: 0, y: 0, w: 4, h: 2 },
    { i: "c", x: 0, y: 0, w: 4, h: 2 },
    { i: "d", x: 0, y: 0, w: 4, h: 2 },
    { i: "e", x: 0, y: 0, w: 4, h: 2 },
    { i: "f", x: 0, y: 0, w: 4, h: 2 }
];

export { layout_lg, layout_md, layout_sm, layout_xs, layout_xxs };
